/* FAQ accordion + read more (moved from sections/custom-faq.liquid). */
    (function () {
      function initialiseFaqSection(section) {
        if (!section || section.dataset.faqInitialised === 'true') return;

        section.dataset.faqInitialised = 'true';

        var faqItems = section.querySelectorAll('[data-faq-item]');
        var readMoreButton = section.querySelector('[data-faq-read-more]');
        var readMoreText = section.querySelector('[data-faq-toggle-text]');

        faqItems.forEach(function (item) {
          var button = item.querySelector('.faq-pill-btn');
          var answer = item.querySelector('.faq-pill-ans');

          if (!button || !answer) return;

          button.addEventListener('click', function () {
            var isOpen = item.classList.contains('open');

            faqItems.forEach(function (otherItem) {
              var otherButton = otherItem.querySelector('.faq-pill-btn');
              var otherAnswer = otherItem.querySelector('.faq-pill-ans');

              otherItem.classList.remove('open');

              if (otherButton) {
                otherButton.setAttribute('aria-expanded', 'false');
              }

              if (otherAnswer) {
                otherAnswer.hidden = true;
              }
            });

            if (!isOpen) {
              item.classList.add('open');
              button.setAttribute('aria-expanded', 'true');
              answer.hidden = false;
            }
          });
        });

        if (readMoreButton && readMoreText) {
          readMoreButton.addEventListener('click', function () {
            var isExpanded = section.classList.toggle('show-all-faqs');

            readMoreButton.setAttribute(
              'aria-expanded',
              isExpanded ? 'true' : 'false'
            );

            readMoreText.textContent = isExpanded
              ? readMoreButton.dataset.readLessText
              : readMoreButton.dataset.readMoreText;

            if (!isExpanded) {
              section
                .querySelectorAll('.faq-item--extra.open')
                .forEach(function (extraItem) {
                  var extraButton =
                    extraItem.querySelector('.faq-pill-btn');
                  var extraAnswer =
                    extraItem.querySelector('.faq-pill-ans');

                  extraItem.classList.remove('open');

                  if (extraButton) {
                    extraButton.setAttribute(
                      'aria-expanded',
                      'false'
                    );
                  }

                  if (extraAnswer) {
                    extraAnswer.hidden = true;
                  }
                });
            }
          });
        }
      }

      document.querySelectorAll('[data-faq-section]').forEach(initialiseFaqSection);

      document.addEventListener(
        'shopify:section:load',
        function (event) {
          var loadedSection = event.target.querySelector(
            '[data-faq-section]'
          );

          initialiseFaqSection(loadedSection);
        }
      );
    })();
